import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Cross-LOM Compare tray
 * ──────────────────────
 * Holds 2-3 BP IDs the user wants to compare side-by-side. Persists to
 * localStorage so switching pages / refreshing doesn't lose selection.
 *
 * `items` is a list of {bpId, lomId, lomTitle, title} objects (the extra
 * fields are cached so the header badge can render without hitting the
 * BP registry on every render).
 */
const MAX_ITEMS = 3;

export const useCompareStore = create(persist((set, get) => ({
  items: [],

  add: (item) => {
    if (!item?.bpId) return { ok: false, reason: 'invalid' };
    const cur = get().items;
    if (cur.find(x => x.bpId === item.bpId)) return { ok: false, reason: 'duplicate' };
    if (cur.length >= MAX_ITEMS) return { ok: false, reason: 'full' };
    set({ items: [...cur, item] });
    return { ok: true };
  },

  remove: (bpId) => set({ items: get().items.filter(x => x.bpId !== bpId) }),
  clear:  ()     => set({ items: [] }),
  has:    (id)   => !!get().items.find(x => x.bpId === id),
}), { name: 'luminex:compare-tray' }));

export const MAX_COMPARE_ITEMS = MAX_ITEMS;
